import { ProductCatalogueProduct } from '@aglenergy/shared-library';
import { store } from 'app/shared/store/store';
import { mobileProductSearchApiService } from 'app/mobile/services/mobile-product-search-api/mobile-product-search-api.service';
import { ProductCategory } from 'app/shared/models/product-category.model';
import { ProductSearchRequestModel } from 'app/shared/models/productSearchRequestModel';
import { ProductsResponse } from 'app/shared/models/product-response.model';
import { productsSessionStorageService } from 'app/shared/services/product-session-storage/product-session-storage.service';
import { StoreKeys } from 'app/shared/constants/store-keys.enum';

class MobileProductService {
  private productCategory: ProductCategory = 'mobile plan';

  private async getDefaultProducts(): Promise<ProductsResponse> {
    const couponCode = store.get('couponCode') ?? null;
    const storageProductSessionData = productsSessionStorageService.getLatestProducts(this.productCategory);

    if (!storageProductSessionData) {
      const defaultProductSearchRequest: ProductSearchRequestModel = {
        couponCode,
        state: 'All',
        webCampaignId: store.get(StoreKeys.webId) ?? null
      };

      return await mobileProductSearchApiService.getProducts(defaultProductSearchRequest).then((response) => {
        productsSessionStorageService.upsertProducts(response, this.productCategory);
        return response;
      });
    }
    return await storageProductSessionData.response;
  }

  public async getProducts(): Promise<ProductsResponse> {
    return await this.getDefaultProducts();
  }

  public async getMobileProductBySku(productSku: string): Promise<ProductCatalogueProduct> {
    const mobileProducts = productsSessionStorageService.getLatestProductsByProductCategory('mobile plan');
    let findProduct: ProductCatalogueProduct = null;
    if (mobileProducts) findProduct = mobileProducts.response.products.find((prod) => prod.sku === productSku);
    if (!findProduct) {
      const productResponse = await mobileProductSearchApiService.getMobileProduct(productSku);
      findProduct = productResponse.products?.find((x) => x.sku === productSku);
    }

    return findProduct;
  }
}

export const mobileProductService = new MobileProductService();
